// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"296":"ea88be26","1130":"4afafdf3"}[chunkId] || chunkId) + "." + {"296":"4031e8dca9c09163","445":"220a909dbc52e213","1130":"1fb4305db9724765","1322":"36981bf347eca9c3","5180":"86def2ebb196047a","6610":"f4031722607ca927","8307":"a3934908757cdd83","8950":"3d8274d8679c292f"}[chunkId] + ".js";
};